import React, { useEffect, useState } from 'react';
import { clients } from '../../mockData';

const ClientsSection = () => {
  const [offset, setOffset] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setOffset((prev) => (prev + 1) % clients.length);
    }, 3000);
    return () => clearInterval(interval);
  }, []);

  // Duplicate clients array for seamless loop
  const extendedClients = [...clients, ...clients];

  return (
    <section className="py-16 bg-gray-50">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold text-gray-800">Happy Clients</h2>
        </div>

        <div className="overflow-hidden">
          <div
            className="flex transition-transform duration-1000 ease-in-out"
            style={{
              transform: `translateX(-${(offset * 100) / 6}%)`
            }}
          >
            {extendedClients.map((client, index) => (
              <div
                key={`${client.id}-${index}`}
                className="flex-shrink-0 w-1/2 md:w-1/3 lg:w-1/6 px-4"
              >
                <div className="bg-white p-6 flex items-center justify-center h-32 grayscale hover:grayscale-0 transition-all duration-300">
                  <img
                    src={client.logo}
                    alt={`Client ${client.id}`}
                    className="max-w-full max-h-full object-contain"
                  />
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ClientsSection;